<template>
  <span class="btn-box">
    <!-- <span class="primary cur" @click="queryGasStation">查询油站</span> -->
    <span class="primary cur" @click="oilAccountRecharge">充值</span>
    <el-dialog
      :close-on-click-modal="false"
      title="油账户充值"
      :lock-scroll="true"
      :visible.sync="dialogFormVisible"
    >
      <section v-loading="getDetailLoading">
        <qx-custom-form
          @sub="sub"
          :noSubBtn="true"
          ref="customForm"
          :formData="formData"
        />
      </section>
      <section slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="customFormPost"
          :loading="subLoading || getDetailLoading"
          >确 定</el-button
        >
      </section>
    </el-dialog>
  </span>
</template>

<script>
export default {
  props: {
    balanceData: {
      type: Object,
      default: () => ({}),
    },
    driverOilForPayWay: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '充值金额',
            value: 'balance',
            type: 'input',
            default: '0',
            placeholder: '请输入充值金额',
          },
          {
            label: '分配油来源',
            value: 'oilAccountType',
            type: 'select',
            placeholder: '请输入分配油来源',
            default: '1',
            options: [
              { label: '本车队定点油', value: '1' },
              { label: '找油-无发票', value: '2' },
              { label: '找油-有发票', value: '3' },
            ],
            onChange: (val) => {
              this.$emit('getOilAccountType', val);
            },
          },
        ],
        rules: { // 表单验证规则
          balance: [ // 充值金额
            { required: true, message: '请输入充值金额', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show () {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm.reset();
        // 只显示输入的充值余额
        this.$refs.customForm.setVal('balance', this.balanceData.sInputOilBalance || '0');
        this.$refs.customForm.setVal('oilAccountType', this.balanceData.oilAccountType || '0');
      });
    },

    // 修改
    customFormPost () {
      this.$refs.customForm.sub();
    },

    // 查询加油站
    queryGasStation () {
      this.$message({
        type: 'info',
        message: '暂未开发',
      });
    },

    // 充值
    oilAccountRecharge () {
      this.show();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = false;

      if (this.driverOilForPayWay.costOil > 0 || this.driverOilForPayWay.contractOil > 0) {
        this.$refs.customForm.setVal('balance', '0');
        this.$message({
          type: 'info',
          message: '司机账户还有其他模式的油费，不允许充值!',
        });
        return;
      }

      this.dialogFormVisible = false; // 关闭弹窗
      this.balanceData.sInputOilBalance = parseFloat(this.$refs.customForm.getVal('balance'));
      this.$emit('sub', {
        sInputOilBalance: this.balanceData.sInputOilBalance,
        oilAccountType: this.$refs.customForm.getVal('oilAccountType'),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-box {
  span {
    margin-left: 15px;
  }
}
</style>
